import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Sidebar = styled.div`
	width: ${({ isopen }) => (!isopen ? 'var(--closedSideBar)' : 'var(--sidebarWidth)')};
	height: 100%;
	background: var(--white);
	position: sticky;
	top: 0;
	z-index: var(--z-index-9);
	overflow: hidden;
	transition:
		width 0.3s ease-in-out,
		opacity 0.3s ease-in-out;

	border-right: 1px solid var(--border-color);
	body[dir='rtl'] & {
		border-right: unset;
		border-left: 1px solid var(--border-color);
	}

	@media ${Breakpoints.mobile} {
		width: ${({ isopen }) => (!isopen ? '0' : 'var(--sidebarWidth)')};
		opacity: ${({ isopen }) => (!isopen ? '0' : '1')};
		position: fixed;
	}

	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

export const SettingsButtonCss = css`
	justify-content: flex-start;
	color: var(--blue) !important;
	text-decoration: underline !important;
	.typography {
		font-weight: 500;
		font-size: var(--paragraph2-font-size);
	}

	[dir='rtl'] & {
		.icon {
			rotate: 180deg;
		}
	}
`;

export const SidebarHeader = styled.div`
	display: block;
	padding: var(--leftMenuContainerPadding);

	img {
		transition: all 0.3s ease-in-out;
		width: var(--logoSize) !important;
		height: var(--logoSize) !important;
		border-radius: var(--small-border-radius);
		cursor: pointer;
		border: 1px solid white;
	}

	.sidebarToggleIcon {
		transform: ${({ isopen }) => !isopen && 'rotateZ(180deg)'};
		transform-origin: center;
		cursor: pointer;
		transition: all 0.3s ease-in-out;
		padding: 2rem;

		body[dir='rtl'] & {
			transform: ${({ isopen }) => !isopen && 'rotateZ(-180deg)'};
		}
	}
`;

export const SettingsHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.4rem;
	margin-top: 0;

	> span {
		padding: var(--buttonMediumPadding);
	}
`;

export const SidebarFlex = styled.div`
	display: ${({ isopen }) => (isopen ? 'flex' : 'block')};
	justify-content: space-between;
	margin-bottom: 2rem;
`;

export const SidebarLogo = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;

export const SidebarBodyContainer = styled.div`
	width: 100%;
	height: 100%;
	overflow-x: hidden;
	overflow-y: auto;
	flex: 1;
	:hover {
		overflow-y: auto;
	}
`;

export const SettingsPanelButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0.2rem;
	gap: 0.4rem;
	background-color: var(--background-1);
	border: 1px solid var(--border-color);
	border-radius: 0.6rem;
	margin-top: 0;

	button {
		&.home-btn > .typography {
			${({ isOpenSettings }) => !isOpenSettings && 'font-weight: 500 !important;'}
		}

		&.settings-btn > .typography {
			font-weight: 400 !important;
			${({ isOpenSettings }) => isOpenSettings && 'font-weight: 500 !important;'}
		}
	}
`;

export const SettingsPanelMobileButtonContainer = styled.div`
	margin-top: 6.5rem;
	margin-bottom: -1rem;

	> div {
		height: 2.7rem !important;
		width: 5rem !important;
		min-width: 5rem !important;
	}

	input:checked ~ .slider::before {
		transform: translateX(2.3rem) !important;

		body[dir='rtl'] & {
			transform: translateX(-2.3rem) !important;
		}
	}

	label {
		background-color: var(--background-1) !important;
		border: 1px solid var(--border-color) !important;
	}

	.slider {
		background-color: transparent !important;

		::before {
			width: 2rem !important;
			height: 2rem !important;
			background-color: var(--black) !important;
		}
	}
`;

export const SidebarBodyWrapper = styled.div`
	display: flex;
	flex-direction: row;
	transform: ${({ isopen }) => (!isopen ? 'translate(0, 5rem)' : 'translate(0, 0)')};
	transition: all 500ms ease-in-out;
	margin-top: ${({ isopen }) => (isopen ? '0' : '-4.8rem')};

	&.slide-right {
		transform: ${({ isopen }) => (!isopen ? 'translate3d(-100%, 5rem, 0)' : 'translate3d(-100%, 0, 0)')};

		body[dir='rtl'] & {
			transform: ${({ isopen }) => (!isopen ? 'translate3d(100%, 5rem, 0)' : 'translate3d(100%, 0, 0)')};
		}
	}
`;

export const SidebarBody = styled.div`
	flex: 1 0 100%;
	width: 100%;
	max-height: var(--sideBarScrollHeight);
	padding: ${({ isopen }) => (isopen ? ' var(--leftMenuContainerPadding)' : '0 1rem')};

	gap: ${({ isopen }) => (isopen ? '1.2rem' : '0')};
	display: flex;
	flex-direction: column;

	> * {
		width: 100%;
	}

	@media ${Breakpoints.mobile} {
		max-height: ${({ isopen }) => (!isopen ? 'var(--sideBarScrollHeight)' : '100%')};
		background: var(--white);
	}
`;

export const SidebarFooter = styled.div`
	display: flex;
	flex-direction: column;
	padding: var(--leftMenuContainerPadding);
	z-index: var(--z-index-9);
	background-color: var(--white);

	button.back {
		color: var(--blue) !important;
		span.typography {
			color: var(--blue) !important;
		}
		:hover,
		:active,
		:focus {
			color: var(--blue) !important;
			span.typography {
				color: var(--blue) !important;
			}
		}
	}
`;

export const LinkComponent = styled.div`
	display: flex;
	flex-direction: column;
	align-self: center;
	svg {
		width: 3.5rem !important;
	}

	div.arrow {
		svg {
			color: var(--blue) !important;
			background: white;
			padding: 1px !important;
			border-radius: 2rem;
			font-size: 1.6rem !important;
		}
	}
`;

export const SidebarTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`;

export const CloseMenuWrapper = styled.div`
	border-bottom: 1px solid var(--border-color);
`;

export const SideBarTextColor = css`
	color: var(--sidebarSelectedTextColor) !important;
`;

export const HeaderButtonCss = css`
	justify-content: space-between;

	> .icon > svg {
		transition: all 0.3s ease-in-out;
	}
`;
export const Separator = styled.div`
	height: 1px;
	background-color: var(--border-color);
	margin-block: var(--padding-3);
`;
export const LinkButtonCss = ({ isopen }) => css`
	justify-content: space-between;
	padding: var(--sideBarItemPadding) !important;
	padding: 0.25rem 0 !important;
	min-height: 4.23rem;

	> .content {
		display: flex;
		gap: 0.5rem;
		overflow: hidden;
		${!isopen && 'margin: auto'};

		span {
			align-self: center;
		}
	}

	&.black {
		background-color: var(--background-4) !important;

		.icon {
			color: var(--alwaysWhiteColor);
		}
	}
`;

export const PopperContainer = styled.div`
	box-shadow: var(--container-box-shadow);
	background: var(--modal-bg-3);
	padding: var(--padding-2);

	svg {
		width: 3.5rem !important;
	}
`;

export const PopperCss = css`
	padding-left: 2rem;

	body[dir='rtl'] & {
		padding-left: unset;
		padding-right: 2rem;
	}
`;

export const LanguageMenuCss = css`
	padding-left: 4rem;

	body[dir='rtl'] & {
		padding-left: unset;
		padding-right: 4rem;
	}
`;

export const UpgradeButtonCss = css`
	transition: all 0.3s ease-in-out;
	align-self: center;
	margin-bottom: var(--margin-2);
`;

export const UpgradeButtonTextContainer = styled.div`
	display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
	align-items: center;
	justify-content: center;
	gap: 0.8rem;
	flex: 1;
	& > img {
		border-radius: 50%;
	}
`;

export const BadgeContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	flex: 1;
	& > div {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 1rem;
	}
`;

export const ProfileButtonCss = css`
	justify-content: space-between;
	padding: var(--padding-1) !important;

	> .profile {
		display: flex;

		> img {
			border-radius: 50%;
			object-fit: contain;
		}

		> .text {
			flex-wrap: wrap;
			margin-left: var(--margin-2);
			max-width: 14rem;
			body[dir='rtl'] & {
				margin-left: unset;
				margin-right: var(--margin-2);
			}

			> .typography {
				text-align: left;
			}
		}
	}

	:hover {
		svg {
			transform: rotate(-90deg);
			transition: all 0.3s ease-in-out;

			body[dir='rtl'] & {
				transform: rotate(90deg);
			}
		}
	}
`;

export const SwitchPopperContainer = styled.div`
	box-shadow: var(--container-box-shadow);
	background: var(--modal-bg-3);
	border-radius: var(--small-border-radius);
`;

export const PaddingDiv = styled.div`
	margin: var(--margin-5);
	margin-bottom: 0;
	padding-top: var(--padding-5);
	padding-bottom: var(--padding-5);
`;

export const ProfileOuterRow = styled.div`
	border-bottom: 1px solid var(--border-color);
	margin-bottom: 1rem;
`;

export const ProfileInnerRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 390px;
	height: 62px;
`;

export const TimeLeft = styled.div`
	width: fit-content;
	padding: 1rem;
	margin-bottom: 1rem;
	border-radius: var(--small-border-radius);
	display: flex;
	gap: 1rem;
	background-color: var(--green-10);
	color: var(--green);
`;

export const SettingsContainer = styled.div`
	border-top: ${({ isOpen }) => isOpen && '1px solid var(--border-color)'};
	border-bottom: 1px solid var(--border-color);
	margin-block: 1.75rem;
	padding-block: 0.7rem;
	button {
		justify-content: flex-start;
		&.black {
			background-color: var(--background-4) !important;
			.icon {
				color: var(--alwaysWhiteColor);
			}
		}
	}
`;
